export default __webpack_public_path__ + "media/gallery/adobe-stock-d1858ee0.jpg";